import { z } from "zod";

export const serverResponse = z.object({
  password: z.string(),
});
